const masteringIT = {
    "view": {
        "table": {
            "title": "La tua lista di Mastering",
            "column": {
                "created_by": "Creato da",
                "total_songs": "Numero di Canzoni",
                "mastered_songs": "Totale Canzoni Masterizzate",
                "created": "Data di Creazione",
                "action": "Azione"
            },
            "button": {
                "open": "APRI",
                "edit": "MODIFICA",
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            }
        },
        "message": {
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzione.",
            "subscriptionUpgrade": "Il tuo piano di abbonamento attuale non supporta questa funzione. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzione.",
            "noCredits": "Non hai più crediti per il mastering audio. Scopri di più sui crediti <1>qui</1> e contatta il nostro team di supporto.",
            "learnMore": "Scopri tutto sul Mastering Audio <1>qui</1>. Per ulteriori informazioni e <3>crediti</3>, contatta il nostro team di supporto."
        }
    },
    "add": {
        "form": {
            "step1": {
                "title": "Quante canzoni desideri masterizzare?",
                "label": {
                    "number_of_songs": "Numero di Canzoni"
                },
                "option": {
                    "songsCount": {
                        "selectNoOfSongs": "Seleziona il numero di canzoni",
                        "song": "Canzone",
                        "songs": "Canzoni"
                    }
                },
                "button": {
                    "continue": "Continua"
                }
            },
            "step2": {
                "title": "Seleziona le tue canzoni per il mastering",
                "button": {
                    "save": "Salva"
                }
            }
        },
        "message": {
            "uploadSuccess": "Canzoni per il Mastering Audio caricate con successo!",
            "creationSuccess": "Il Mastering Audio è stato creato! Ora seleziona le tue canzoni nella sezione sottostante.",
            "error": "Si è verificato un errore. Per favore riprova."
        },
        "modal": {
            "addMastering": {
                "header": "Sei sicuro di voler aggiungere un nuovo mastering?",
                "body": "Nota: Questo comporterà la detrazione di {{credits}} crediti."
            },
            "saveMastering": {
                "header": "Sei sicuro di voler salvare il Mastering Audio?",
                "body": "Nota: Assicurati di caricare i file audio corretti poiché non possono essere modificati una volta salvati."
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "selectSongs": "Seleziona le tue canzoni per il mastering"
            },
            "button": {
                "save": "Salva"
            }
        },
        "message": {
            "success": "Mastering Audio aggiornato con successo!",
            "errorCantUpdate": "Il Mastering Audio non può essere aggiornato una volta caricate le canzoni!",
            "errorMasteringDoesNotExist": "Il mastering non può essere aggiornato poiché non esiste!",
            "error": "Si è verificato un errore. Per favore riprova."
        },
        "modal": {
            "saveMastering": {
                "header": "Sei sicuro di voler salvare il Mastering Audio?",
                "body": "Nota: Assicurati di caricare i file audio corretti poiché non possono essere modificati una volta salvati."
            }
        }
    },
    "viewSongs": {
        "title": "Canzoni Mastering Audio",
        "table": {
            "column": {
                "name": "Nome",
                "preset": "Preset",
                "intensityAndLoudness": "Intensità & Volume",
                "preview": "Anteprima",
                "master": "Master",
                "previewResult": "Risultato Anteprima",
                "masteringResult": "Risultato Mastering",
                "mastered": "Masterizzato",
                "action": "Azione"
            },
            "label": {
                "previewAttemptsLeft": "{{count}} Rimasti",
                "notAvailable": "Non Disponibile"
            },
            "button": {
                "generate": "Genera",
                "edit": "Modifica",
                "exportCsv": "Esporta CSV"
            },
            "option": {
                "preset": {
                    "acoustic": "Acustico",
                    "allGenres": "Tutti i Generi",
                    "classical": "Classica",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "Musica EDM",
                    "electronic": "Elettronica",
                    "electronicRaw": "Elettronica Grezza",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Musica Pop",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Focalizzato sulla Voce"
                }
            },
            "message": {
                "previewDownloadTooltip": "L'anteprima è in fase di generazione. Attendere 5-6 minuti per vederla apparire.",
                "masteringDownloadTooltip": "Il mastering è in corso. Attendere 7-15 minuti per vederlo apparire.",
                "alreadyMasteredTooltip": "Questa canzone è già masterizzata."
            }
        },
        "message": {
            "error": "Qualcosa è andato storto! Ricarica la pagina e riprova!",
            "successMaster": "Canzone inviata per la generazione del Mastering!<br/>Nota: Controlla tra pochi minuti poiché ci vogliono 7-15 minuti per generare il mastering.",
            "successPreview": "Canzone inviata per la generazione dell'Anteprima del Mastering!<br/>Nota: Controlla tra pochi minuti poiché ci vogliono 5-6 minuti per generare l'anteprima del mastering."
        },
        "modal": {
            "generateMastering": {
                "header": "Genera Mastering",
                "body": "Sei sicuro di voler generare il mastering? Questa è un'azione irreversibile! Il risultato del master apparirà entro 7-15 minuti.",
                "message": {
                    "success": "Canzone inviata per la generazione del Mastering!"
                }
            },
            "generateMasteringPreview": {
                "header": "Genera Anteprima Mastering",
                "body": "Sei sicuro di voler generare l'anteprima del mastering? Il risultato dell'anteprima apparirà entro 5-6 minuti",
                "message": {
                    "success": "Canzone inviata per la generazione dell'Anteprima del Mastering!"
                }
            }
        }
    },
    "songParametersUpdate": {
        "title": "Modifica Parametri Canzone",
        "form": {
            "label": {
                "intensity": "Intensità",
                "loudness": "Volume",
                "preset": "Preset"
            },
            "placeholder": {
                "preset": "Seleziona Preset"
            },
            "option": {
                "preset": {
                    "acoustic": "Acustico",
                    "allGenres": "Tutti i Generi",
                    "classical": "Classica",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "Musica EDM",
                    "electronic": "Elettronica",
                    "electronicRaw": "Elettronica Grezza",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Musica Pop",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Focalizzato sulla Voce"
                }
            },
            "button": {
                "submit": "Invia"
            },
            "message": {
                "intensityTooltip": "La quantità di dinamiche, EQ e processi applicati alla tua canzone in relazione alla traccia complessiva e al preset selezionato. L'utilizzo massimo si verificherà al 100%. Consigliamo di sperimentare con questa impostazione per trovare il punto ideale che si adatta meglio a te.",
                "loudnessTooltip": "Il livello target di volume integrato. Misurato in unità di volume relative alla scala completa (LUFS). Consigliamo di sperimentare con questa impostazione per trovare il punto ideale che si adatta meglio a te. A seconda dello stile e del genere della tua canzone, i migliori risultati dovrebbero apparire tra -15 e -9 db"
            }
        },
        "message": {
            "success": "I parametri della canzone sono stati aggiornati!",
            "error": "Qualcosa è andato storto! Ricarica la pagina e riprova!",
            "songMastered": "I parametri della canzone non possono essere aggiornati una volta che la canzone è stata masterizzata!"
        }
    },
    "songRow": {
        "label": {
            "songs": "Canzoni",
            "name": "Nome",
            "genre": "Genere",
            "preset": "Preset",
            "intensity": "Intensità",
            "loudness": "Volume",
            "audioFile": "File Audio"
        },
        "placeholder": {
            "name": "es. Nome Canzone",
            "genre": "es. Pop",
            "preset": "Seleziona Preset"
        },
        "option": {
            "preset": {
                "acoustic": "Acustico",
                "allGenres": "Tutti i Generi",
                "classical": "Classica",
                "clubHouseTechno": "Club - House - Techno",
                "edmMusic": "Musica EDM",
                "electronic": "Elettronica",
                "electronicRaw": "Elettronica Grezza",
                "hipHop": "Hip Hop",
                "hipHopBass": "Hip Hop Bass",
                "popMusic": "Musica Pop",
                "popRnB": "Pop & RnB",
                "rockMetal": "Rock & Metal",
                "trap": "Trap",
                "vocalFocused": "Focalizzato sulla Voce"
            }
        },
        "message": {
            "intensityTooltip": "La quantità di dinamiche, EQ e processi applicati alla tua canzone in relazione alla traccia complessiva e al preset selezionato. L'utilizzo massimo si verificherà al 100%. Consigliamo di sperimentare con questa impostazione per trovare il punto ideale che si adatta meglio a te.",
            "loudnessTooltip": "Il livello target di volume integrato. Misurato in unità di volume relative alla scala completa (LUFS). Consigliamo di sperimentare con questa impostazione per trovare il punto ideale che si adatta meglio a te. A seconda dello stile e del genere della tua canzone, i migliori risultati dovrebbero apparire tra -15 e -9 db",
            "audioFileTooltip": "I formati audio supportati sono: AAC, AIFF, FLAC, MP3, OPUS, VORBIS e WAV. Consigliamo vivamente di utilizzare tipi di file lossless come AIFF, FLAC o WAV. Il nostro strumento di mastering restituirà sempre lo stesso tipo di file dell'originale. Tieni presente che hai bisogno di un file WAV a 16 bit, 44.1 khz per la distribuzione.",
            "errorSongNameRequired": "Per favore inserisci il nome della canzone",
            "errorSongNameLength": "Il nome della canzone non deve superare gli 80 caratteri.",
            "errorGenreRequired": "Per favore inserisci il genere della canzone",
            "errorGenreLength": "Il genere della canzone non deve superare i 50 caratteri.",
            "errorPresetRequired": "Deve essere selezionato un preset.",
            "errorAudioFileRequired": "Per favore seleziona il file della canzone",
            "errorAudioFileValid": "Per favore carica un file audio valido"
        }
    },
    "masteringConfirmModal": {
        "header": "Sei sicuro di voler salvare il Mastering Audio?",
        "body": "Nota: Assicurati di caricare i file audio corretti poiché non possono essere modificati una volta salvati.",
        "button": {
            "cancel": "Annulla",
            "confirm": "Conferma"
        },
        "message": {
            "error": "Qualcosa è andato storto! Ricarica la pagina e riprova!"
        }
    }
};

export default masteringIT;